import store from '@/store'
import { computed, onMounted, onUnmounted } from '@vue/composition-api'

const useWrtcStats = () => {
  onMounted(() => {
    store.dispatch.opsmonitor.subscribeWrtcStats().catch((error) => {
      console.error('useWrtcStats: could not subscribe wrtcstats', error)
    })
  })

  onUnmounted(() => {
    store.dispatch.opsmonitor.unsubscribeWrtcStats().catch((error) => {
      console.error('useWrtcStats: could not unsubscribe wrtcstats', error)
    })
  })

  const wrtcStats = computed(() => store.state.opsmonitor.wrtcstats)

  return {
    wrtcStats
  }
}

export default useWrtcStats
